import React from "react";
import { motion } from "framer-motion";

const circles = [
  {
    size: "aspect-square h-full",
    image: "https://a.storyblok.com/f/313778/848x722/3f971edc17/ellipse-3513.png",
    duration: 20,
    direction: 1,
    zIndex: 6,
  },
  {
    size: "aspect-square  h-full",
    image: "https://a.storyblok.com/f/313778/595x613/ec8fecd765/group-1000007244.png",
    duration: 25,
    direction: -1,
    zIndex: 5,
  },
  {
    size: "aspect-square  h-full",
    image: "https://a.storyblok.com/f/313778/576x576/4cf16a554d/ellipse-3521.png",
    duration: 22,
    direction: 1,
    zIndex: 4,
  },
  {
    size: "aspect-square h-full",
    image: "https://a.storyblok.com/f/313778/810x810/4828c8381d/ellipse-3514.png",
    duration: 30,
    direction: -1,
    zIndex: 3,
  },
  {
    size: "aspect-square h-full",
    image: "https://a.storyblok.com/f/313778/751x795/17f1c76ee9/group-1000007245.png",
    duration: 28,
    direction: 1,
    zIndex: 2,
  },
  {
    size: "aspect-square  h-full",
    image: "https://a.storyblok.com/f/313778/970x913/cab1c2129c/group-1000007246.png",
    duration: 26,
    direction: -1,
    zIndex: 1,
  },
];

const SpinningBackground = () => {
  return (
    <div className="absolute inset-0 flex justify-center items-center z-10 h-[70%] top-0 ">
      <div className="absolute top-[1%] aspect-square h-full">
        {circles.map((circle, index) => (
          <motion.div
            key={index}
            className={`absolute inset-0 m-auto rounded-full bg-cover bg-center ${circle.size}`}
            style={{ backgroundImage: `url(${circle.image})`, zIndex: circle.zIndex }}
            animate={{ rotate: [0, 360 * circle.direction] }}
            transition={{ repeat: Infinity, duration: circle.duration, ease: "linear" }}
          />
        ))}
      </div>
    </div>
  );
};

export default SpinningBackground;
